import { useLocale } from 'next-intl';

/**
 * The public pilot offer shown on the landing page. Every price on the page is rendered from
 * these values; the message strings only hold the placeholder (`{perUserMonthly}`).
 */
export const PILOT_OFFER = { perUserMonthlyEur: 5 } as const;

// Portuguese copy is European Portuguese; plain 'pt' would give the Brazilian format.
const INTL_LOCALES: Record<string, string> = { pt: 'pt-PT' };

/** Formats a whole euro amount for the given app locale, without decimals. */
export function formatOfferEuro(value: number, locale: string): string {
  return new Intl.NumberFormat(INTL_LOCALES[locale] ?? locale, {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

/** The offer prices formatted for the current locale, ready to pass as message values. */
export function useOfferPrices(): { perUserMonthly: string } {
  const locale = useLocale();
  return {
    perUserMonthly: formatOfferEuro(PILOT_OFFER.perUserMonthlyEur, locale),
  };
}
